export default __webpack_public_path__ + "static/media/1690.da25a4af.png";